import { localize } from '@saviynt/common';

import { getMessageKey } from '../../../utils/utils';
import {
  CERTS_LIST_ALL_TAB,
  CERTS_LIST_CANCELED_TAB,
  CERTS_LIST_DONE_TAB,
  CERTS_LIST_EXPIRED_TAB,
  CERTS_LIST_TODO_TAB,
} from '../constant';

import {
  CAMP_TYPE_AM,
  CAMP_TYPE_AO,
  CAMP_TYPE_EO,
  CAMP_TYPE_OO,
  CAMP_TYPE_RO,
  CAMP_TYPE_SA,
  CAMP_TYPE_SC,
  CAMP_TYPE_UM,
} from './constant';

export const getTileTabCategory = (statusLabel) => {
  const status = statusLabel?.toLowerCase();
  const isToDoTab = Boolean(
    status === 'preview' ||
      status === 'resume' ||
      status === 'in progress' ||
      status === 'start certification' ||
      status === 'ready to submit'
  );
  const isDoneTab = Boolean(
    status === 'completed' ||
      status === 'fully executed' ||
      status === 'locked' ||
      status === 'lockedandtaskcreated'
  );
  const isCanceledTab = Boolean(status === 'discontinued');
  const isExpiredTab = Boolean(status === 'expired');

  if (isToDoTab) return CERTS_LIST_TODO_TAB;
  if (isDoneTab) return CERTS_LIST_DONE_TAB;
  if (isCanceledTab) return CERTS_LIST_CANCELED_TAB;
  if (isExpiredTab) return CERTS_LIST_EXPIRED_TAB;

  return CERTS_LIST_ALL_TAB; // Default to All tab if no match found in above conditions
};

export const getAlertIconColor = (statusLabel) =>
  getTileTabCategory(statusLabel) === CERTS_LIST_EXPIRED_TAB
    ? 'critical-700'
    : 'warning-500';

export const getIconKind = (kind) => {
  switch (kind) {
    case CAMP_TYPE_EO:
      return 'Entitlement';
    case CAMP_TYPE_UM:
      return 'ConfirmManager';
    case CAMP_TYPE_SC:
      return 'User';
    case CAMP_TYPE_RO:
      return 'role';
    case CAMP_TYPE_SA:
      return 'ServiceAccount';
    case CAMP_TYPE_OO:
      return 'Organization';
    case CAMP_TYPE_AO:
      return 'Applications';
    case CAMP_TYPE_AM:
      return 'ApplicationMetadata';
    default:
      return 'User';
  }
};

export const getStatusIcon = (
  messages,
  intl,
  tab,
  statusLabel,
  isAdminLogin = false
) => {
  switch (tab) {
    case CERTS_LIST_TODO_TAB:
      return {
        kind: 'StatusToDo',
        iconColor: 'info-700',
        text: isAdminLogin
          ? messages.CERTS_INCOMPLETE ||
            localize(intl, getMessageKey('CERTS_INCOMPLETE'))
          : messages.CERTS_TODO || localize(intl, getMessageKey('CERTS_TODO')),
        textColor: '--color-foreground-info-medium',
      };

    case CERTS_LIST_DONE_TAB:
      return {
        kind: 'StatusCompleteFill',
        iconColor: 'success-700',
        text: isAdminLogin
          ? messages.CERTS_COMPLETE ||
            localize(intl, getMessageKey('CERTS_COMPLETE'))
          : messages.CERTS_DONE || localize(intl, getMessageKey('CERTS_DONE')),
        textColor: '--color-foreground-success-medium',
      };

    case CERTS_LIST_CANCELED_TAB:
      return {
        kind: 'StatusCanceled',
        iconColor: 'neutral-600',
        text:
          messages.CERTS_CANCELLED ||
          localize(intl, getMessageKey('CERTS_CANCELLED')),
        textColor: '--color-foreground-neutral-subtle',
      };

    case CERTS_LIST_EXPIRED_TAB:
      return {
        kind: 'StatusError',
        iconColor: 'critical-700',
        text:
          messages.CERTS_EXPIRED ||
          localize(intl, getMessageKey('CERTS_EXPIRED')),
        textColor: '--color-foreground-critical-medium,',
      };

    default:
      return {
        kind: 'StatusToDo',
        iconColor: 'info-700',
        text: statusLabel,
        textColor: '--color-foreground-info-medium',
      };
  }
};

export const getTileMetaData = (messages, intl, node, isAdminLogin = false) => {
  if (node) {
    const tab = getTileTabCategory(node?.statusLabel);
    const {
      kind: statusIconKind,
      iconColor: statusIconColor,
      text: statusText,
      textColor: statusTextColor,
    } = getStatusIcon(messages, intl, tab, node?.statusLabel);

    return {
      id: node?.certkey,
      title: node?.certificationName,
      campaignType: node?.cert_type_id,
      campaignTypeName: node?.campaigntype,
      tileCampaignKey: node?.campaignKey,
      certificationType: node?.certificationType,
      tileStatusLabel: node?.statusLabel,
      isPrimaryCertifierActive: Boolean(node?.certifierStatus === 1),
      autoRevoke: node?.autoRevoke,
      isDue: Boolean(node?.autoRevoke && !isAdminLogin),
      newCertUX: node?.newCertUX,
      certDetailsUrl: node?.certDetailsUrl,
      tab,
      actions: node?.tracker?.actions,
      progress: node?.progress,
      statusIconKind,
      statusIconColor,
      statusText,
      statusTextColor,
      certificationConfig: node?.certificationConfig,
      certifierUserKey: node?.certifierUserKey,
    };
  }

  return null;
};
